import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ContentSection } from './contentsection';
import { contentSections } from '../constant/self-employment-sections.constant';
import { selfImage } from './images/jpg/selfEmploymentImages';

const SelfEmploymentPageComponent: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="self-employment-page px-0">
            <section className="self-employment-hero-section px-0">
                <Container>
                    <Row className="align-items-start">
                        <Col sm={6} className='px-0'>
                            <h2 className="Heading_h1">
                                {t('WHAT_DOES_SELF_EMPLOYMENT_MEAN')}
                            </h2>
                        </Col>
                        <Col sm={6} className='px-0'>
                            <div className="hero-description">
                                <p>{t('SELF_EMPLOYMENT_MEANING_TEXT')}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
          
            <section className="hero-image-section">
                <Container>
                    <Row>
                        <Col className='px-0' >
                            <img src={selfImage} alt="Self Employment" className="img-fluid image-radius-self-employment" />
                        </Col>
                    </Row>
                </Container>
            </section>
         
            {contentSections.map((section, index) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey, textIndex) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}
        </div>
    );
};

export default SelfEmploymentPageComponent;
